import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, AwardIcon, ShieldCheckIcon, LightbulbIcon, HeartHandshakeIcon } from 'lucide-react';
import { AnimatedSection, AnimatedChildren, AnimatedChild } from '../components/ui/AnimatedSection';
import { TextReveal } from '../components/ui/TextReveal';
import { MaskReveal } from '../components/ui/MaskReveal';
import { Parallax3D } from '../components/ui/Parallax3D';
const values = [{
  icon: AwardIcon,
  title: 'Qualität',
  description: 'Wir liefern Ergebnisse, die höchsten Ansprüchen genügen. Jedes Detail zählt, jede Lösung wird gründlich durchdacht und sorgfältig umgesetzt.'
}, {
  icon: ShieldCheckIcon,
  title: 'Zuverlässigkeit',
  description: 'Verbindliche Zusagen, transparente Kommunikation und termingerechte Lieferung. Auf uns können Sie sich verlassen.'
}, {
  icon: LightbulbIcon,
  title: 'Innovation',
  description: 'Wir bleiben neugierig und offen für neue Technologien und Methoden. So finden wir die besten Lösungen für Ihre Herausforderungen.'
}, {
  icon: HeartHandshakeIcon,
  title: 'Partnerschaft',
  description: 'Wir verstehen uns als Teil Ihres Teams. Langfristige Zusammenarbeit auf Augenhöhe ist unser Ziel.'
}];
export function AboutPage() {
  return <div className="w-full" data-id="element-260">
      {/* Hero */}
      <section className="py-24 md:py-32 bg-[#0C0C0F]" data-id="element-261">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-262">
          <AnimatedSection data-id="element-263">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tightest gradient-text max-w-3xl" data-id="element-264">
              Über fooble media
            </h1>
          </AnimatedSection>
          <AnimatedSection delay={0.1} data-id="element-265">
            <p className="mt-6 text-lg md:text-xl text-white/50 max-w-2xl" data-id="element-266">
              Ihr strategischer Partner für digitale Lösungen im DACH-Raum. Wir
              verbinden Technologie, Design und Strategie.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Who We Are */}
      <section className="py-24 md:py-32 bg-[#09090B]" data-id="element-267">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-268">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-269">
            <AnimatedSection variant="slideLeft" data-id="element-270">
              <h2 className="text-3xl md:text-4xl font-bold tracking-tightest gradient-text" data-id="element-271">
                Wer wir sind
              </h2>
              <div className="mt-6 space-y-4 text-lg text-white/50 leading-relaxed" data-id="element-272">
                <p data-id="element-273">
                  fooble media ist eine Full-Service-Digitalagentur mit Fokus
                  auf mittelständische Unternehmen im deutschsprachigen Raum.
                  Seit über einem Jahrzehnt unterstützen wir Unternehmen dabei,
                  ihre digitale Präsenz zu stärken und Prozesse zu optimieren.
                </p>
                <p data-id="element-274">
                  Unser Team vereint Expertise aus Softwareentwicklung, Design,
                  Videoproduktion und strategischer Beratung. Diese Kombination
                  ermöglicht es uns, ganzheitliche Lösungen zu entwickeln – von
                  der ersten Idee bis zur erfolgreichen Umsetzung.
                </p>
                <p data-id="element-275">
                  Wir glauben an langfristige Partnerschaften statt
                  kurzfristiger Projekte. Unser Erfolg misst sich am Erfolg
                  unserer Kunden.
                </p>
              </div>
            </AnimatedSection>
            <AnimatedSection delay={0.1} variant="slideRight" data-id="element-276">
              <MaskReveal className="aspect-[4/3] rounded-2xl overflow-hidden" direction="right" data-id="element-277">
                <Parallax3D className="w-full h-full" tiltX={5} tiltY={3} shiftY={25} data-id="element-278">
                  <div className="relative w-full h-full" data-id="element-279">
                    <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80" alt="fooble media Team" className="w-full h-full object-cover" data-id="element-280" />
                    <div className="absolute inset-0 bg-black/20" data-id="element-281" />
                  </div>
                </Parallax3D>
              </MaskReveal>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 md:py-32 bg-[#0C0C0F]" data-id="element-282">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-283">
          <AnimatedSection data-id="element-284">
            <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-285">
              <h2 className="text-3xl md:text-4xl font-bold tracking-tightest gradient-text" data-id="element-286">
                Unsere Werte
              </h2>
              <p className="mt-4 text-lg text-white/50" data-id="element-287">
                Die Grundsätze, die unsere Arbeit leiten.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedChildren className="grid grid-cols-1 md:grid-cols-2 gap-8" staggerDelay={0.1} data-id="element-288">
            {values.map(value => <AnimatedChild key={value.title} data-id="element-289">
                <div className="p-8 bg-white/5 border border-white/10 rounded-2xl h-full" data-id="element-290">
                  <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center mb-6" data-id="element-291">
                    <value.icon className="w-6 h-6 text-[#E8781A]" data-id="element-292" />
                  </div>
                  <h3 className="text-xl font-semibold text-white" data-id="element-293">
                    {value.title}
                  </h3>
                  <p className="mt-3 text-white/50 leading-relaxed" data-id="element-294">
                    {value.description}
                  </p>
                </div>
              </AnimatedChild>)}
          </AnimatedChildren>
        </div>
      </section>

      {/* Quality Standards */}
      <section className="py-24 md:py-32 bg-[#09090B]" data-id="element-295">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-296">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-297">
            <AnimatedSection className="lg:order-2" variant="slideRight" data-id="element-298">
              <h2 className="text-3xl md:text-4xl font-bold tracking-tightest gradient-text" data-id="element-299">
                Unser Anspruch
              </h2>
              <div className="mt-6 space-y-4 text-lg text-white/50 leading-relaxed" data-id="element-300">
                <p data-id="element-301">
                  Wir setzen auf bewährte Methoden und moderne Technologien, um
                  Lösungen zu entwickeln, die nicht nur heute funktionieren,
                  sondern auch morgen noch relevant sind.
                </p>
                <p data-id="element-302">
                  Jedes Projekt durchläuft einen strukturierten Prozess mit
                  klaren Meilensteinen, regelmäßigen Reviews und transparenter
                  Kommunikation.
                </p>
                <p data-id="element-303">
                  Qualität bedeutet für uns auch, ehrlich zu sein: Wir sagen,
                  was möglich ist – und was nicht. Wir versprechen nur, was wir
                  halten können.
                </p>
              </div>
            </AnimatedSection>
            <AnimatedSection delay={0.1} className="lg:order-1" variant="slideLeft" data-id="element-304">
              <MaskReveal className="aspect-[4/3] rounded-2xl overflow-hidden" direction="left" data-id="element-305">
                <Parallax3D className="w-full h-full" tiltX={5} tiltY={-3} shiftY={25} data-id="element-306">
                  <div className="relative w-full h-full" data-id="element-307">
                    <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80" alt="Büro" className="w-full h-full object-cover" data-id="element-308" />
                    <div className="absolute inset-0 bg-black/20" data-id="element-309" />
                  </div>
                </Parallax3D>
              </MaskReveal>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-[#E8781A]/10 via-[#09090B] to-[#a855f7]/10 border-y border-white/5" data-id="element-310">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-311">
          <AnimatedSection data-id="element-312">
            <div className="max-w-3xl mx-auto text-center" data-id="element-313">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tightest text-white" data-id="element-314">
                Lernen Sie uns kennen.
              </h2>
              <p className="mt-6 text-lg text-white/50" data-id="element-315">
                In einem persönlichen Gespräch erfahren Sie mehr über unsere
                Arbeitsweise und wie wir Sie unterstützen können.
              </p>
              <div className="mt-10" data-id="element-316">
                <Link to="/kontakt" className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#09090B] font-medium rounded-lg hover:bg-white/90 transition-colors" data-id="element-317">
                  Kontakt aufnehmen
                  <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-318" />
                </Link>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}